/* bb-card-swipe — Beyond Bohemian (2026-09-17)
   Keeps the photo dots on touch product cards in step with the swipe strip.
   One delegated listener, so it also covers grids re-rendered by filters.
   The work per event is a few class toggles, so no frame throttling needed. */
(function(){
  if (window.__bbCardSwipe) return;
  window.__bbCardSwipe = true;
  document.addEventListener('scroll', function(event){
    var track = event.target;
    if (!track || !track.classList || !track.classList.contains('bb-flip__track')) return;
    var dots = track.parentNode.querySelectorAll('.bb-flip__dots i');
    if (!dots.length) return;
    var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
    for (var n = 0; n < dots.length; n++) dots[n].classList.toggle('is-on', n === i);
  }, true);
})();
